import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { images, recentBuyers } from "../data/content";
const minutesAgo = [2, 4, 7, 1, 9, 3, 12, 5, 6, 8, 11, 2, 14, 3, 10];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setShow(true);
      hideTimer = window.setTimeout(() => {
        setShow(false);
        window.setTimeout(() => setIndex(i => (i + 1) % recentBuyers.length), 400);
      }, 5000);
    };
    const first = window.setTimeout(cycle, 6000);
    const interval = window.setInterval(cycle, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <AnimatePresence data-id="element-42" data-mp="16467wtvn2xev">
      {show && !dismissed && <motion.div key={buyer.name} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-[92px] left-3 right-3 z-50 flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-3 pr-9 shadow-2xl sm:right-auto sm:max-w-sm" role="status" data-id="element-43" data-mp="117o5i0ns7b5p">
          <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-cream object-contain" data-id="element-44" data-mp="x51ajqvtda4a" />
          <div className="min-w-0 text-sm leading-snug text-navy" data-id="element-45" data-mp="s5om51panuzl">
            <p data-id="element-46" data-mp="s8kk2q156jo1">
              <span className="font-bold" data-id="element-47" data-mp="28k7rwv0imiki">{buyer.name}</span> from <span className="font-bold" data-id="element-48" data-mp="28iwncsz8x6sc">{buyer.country}</span>
            </p>
            <p className="text-navy/70" data-id="element-49" data-mp="23kboawvqct5h">just purchased The Abdominoplasty Master System™</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-cta" data-id="element-50" data-mp="2anji9cw5y368">
              <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-51" data-mp="2fmv3ay3kbutm" />
              Verified · {minutesAgo[index]} min ago
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-navy/40 transition-colors duration-150 hover:text-navy" aria-label="Close notification" data-id="element-52" data-mp="2kkwkfdhfhk2g">
            <XIcon className="h-4 w-4" data-id="element-53" data-mp="1wxof4vk02b0f" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}